import { FC } from 'react';
import Link from 'next/link';
import styles from './TabMenu.module.scss';

interface IBookTabs {
  bookId: number;
  bookType: string;
  reviews?: boolean;
  quotes?: boolean;
  readTxt?: boolean;
  reviewsCount?: number;
  quotesCount?: number;
  bookPageName?: string;
  bookAlias?: string;
}

const TabMenu: FC<IBookTabs> = ({ bookId, bookType, reviews, quotes, readTxt, quotesCount, reviewsCount, bookPageName, bookAlias }) => {
  const getBookPageName = () => (!!bookPageName ? bookPageName : 'О книге');

  return (
    <div className={styles.tabMenu}>
      <div className={!readTxt && !reviews && !quotes ? `${styles.tabMenu__item} ${styles.tabMenu__item_active}` : `${styles.tabMenu__item}`}>
        <Link prefetch={false} className={styles.ref} href={bookAlias ? bookAlias : `/book/${bookId}`}>
          {getBookPageName()}
        </Link>
      </div>
      {reviewsCount! > 0 ? (
        <div className={!!reviews ? `${styles.tabMenu__item} ${styles.tabMenu__item_active}` : `${styles.tabMenu__item}`}>
          <Link prefetch={false} className={styles.ref} href={bookAlias ? `${bookAlias}/reviews` : `/book/${bookId}/reviews`}>
            Отзывы
          </Link>
          <span className={styles.tabMenu__reviewsCount}> {reviewsCount}</span>
        </div>
      ) : (
        ``
      )}

      {bookType === 'book' && (
        <div className={!!readTxt ? `${styles.tabMenu__item} ${styles.tabMenu__item_active}` : `${styles.tabMenu__item}`}>
          <Link prefetch={false} className={styles.ref} href={`/online/${bookId}`}>
            Читать онлайн
          </Link>
        </div>
      )}

      <div className={styles.tabMenu__line}></div>
    </div>
  );
};

export default TabMenu;
